module.exports = __webpack_public_path__ + "img/idlefish-good.f8ff2607.png";